import React from "react"

import StoryblokLink from "../shared/StoryblokLink"

import { renderCardHeadline } from "../contentEdit"

import { OnDemandWebinarSelection } from "../../types"

type ResourceCaseStudyCardProps = {
  content: OnDemandWebinarSelection
  ctaText: string
}

const OnDemandCard = ({ content, ctaText }: ResourceCaseStudyCardProps) => {
  const linkObject = {
    cached_url: content?.full_slug,
    linktype: "story",
  }

  const cardHeadline = renderCardHeadline(
    content?.content?.title,
    "c-resourceCaseStudyCard__heading"
  )

  return (
    <StoryblokLink to={linkObject} className="c-resourceCaseStudyCard">
      <div className="c-resourceCaseStudyCard__hoverWrapper">
        <div
          className="c-resourceCaseStudyCard__imageWrapper"
          style={{
            backgroundImage: `url(${content?.content?.cardImage?.filename})`,
          }}
        />

        <div className="c-resourceCaseStudyCard__content">
          <p className="c-resourceCaseStudyCard__type">
            {content?.content?.component}
          </p>

          {cardHeadline}

          <p className="c-resourceCaseStudyCard__webinarDate">
            {content?.content?.watchTime}
          </p>

          <span className="btn-tertiary hover-bcgUnderline">{ctaText}</span>
        </div>
      </div>
    </StoryblokLink>
  )
}

export default OnDemandCard
